import { Fragment } from "react";
import ContentFAQ from "../../../modules/pages/faq/content/faq";
import FooterPostup from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";

function FAQ() {
  return (
    <Fragment>
      <Menu />
      <ContentFAQ />
      <FooterPostup />
    </Fragment>
  );
}
export default FAQ;
